import { type ReactNode } from 'react'

type NoteProps = {
  /** Falsy, or a list whose falsy members are dropped. Empty renders nothing. */
  parts: ReactNode[] | false | null | 0 | '' | undefined
  flag?: boolean
}

/**
 * A callout that only renders when it has something true to say. Every number
 * in it is computed from the same rows as the chart above, and a premise that
 * stops holding removes its own note instead of lying.
 */
const Note = ({ parts, flag = false }: NoteProps) => {
  if (!parts) return null
  const list = parts.filter(Boolean)
  if (!list.length) return null

  return (
    <div
      className={
        flag
          ? 'bg-flag-soft rounded-lg px-4 py-3'
          : 'bg-surface-secondary rounded-lg px-4 py-3'
      }
    >
      <p className="m-0 text-sm leading-relaxed">
        {list.map((part, i) => (
          <span key={i}>{part}</span>
        ))}
      </p>
    </div>
  )
}

export default Note
